export default "__VITE_ASSET__BOoBqBwZ__"